<template>
  <v-app>
    <router-view />
    <qz-snackbar />
    <qz-confirm />
  </v-app>
</template>

<script>
import QzSnackbar from '@/components/QzSnackbar';
import QzConfirm from '@/components/QzConfirm';
import { useABTastyControllerUI } from '@/composables/useTrackersControllerUI';
import {
  provide,
} from '@vue/composition-api';
import { setupMetaTags } from '@/config/common';

export default {
  name: 'app',
  components: {
    QzSnackbar,
    QzConfirm,
  },
  inject: ['config'],
  metaInfo () {
    return setupMetaTags(this.config);
  },
  setup (props, context) {
    const abTastyControllerUI = useABTastyControllerUI(context);

    abTastyControllerUI.initABTastyCampaignExecute();

    provide('abTastyControllerUI', abTastyControllerUI);
  },
};
</script>
